import { useEffect, useState, useContext } from 'react';
import ContainerPage from '../../componentsNew/ContainerPage';
import { MdOutlineInfo } from 'react-icons/md';
import Typography from '../../componentsNew/Typography';
import ModalAnalytics from './Components/ModalAnalytics';
import { differenceInDays, addMonths, subMonths, getDay, getDaysInMonth } from 'date-fns';
import { ResultadoPalavraChave } from './Components/ResultadoPalavraChave';
import { PanoramaGeral } from './Components/PanoramaGeral';
import { VisaoGeralArtigos } from './Components/VisaoGeralArtigos';
import { ArtigosRascunhoIA } from './Components/ArtigosRascunhoIA';

export function Dashboard({ analytics = false, artigos, postLength, recadastrando, excluir }) {
  const [dataInicial, setDataInicial] = useState(
    new Date(new Date().setMonth(new Date().getMonth() - 1))
  );
  const [dataFinal, setDataFinal] = useState(new Date());
  const [artigoIds, setArtigoIds] = useState([]);

  useEffect(() => {
    if (artigos !== undefined && artigos.length > 0) {
      setArtigoIds(artigos.map(a => parseInt(a.id, 10)));
    }
  }, [artigos]);

  /* 
    useEffect(() => {
      if (postLength < 5 && postLength > 0) setVisibilityPostsAlert(true)
    }, [postLength])

    useEffect(() => { if (postsNoKw.length > 0) setVisibilityAlert(true) }, [postsNoKw]);

    useEffect(() => {
      if (metrics?.length > 0 && (metrics?.length <= 5 || gratuito)) dataChartPopulate(metrics, setDataChart)
    }, [metrics]) 
  */

  useEffect(() => {
    if (Math.abs(differenceInDays(dataInicial, dataFinal)) > getDaysInMonth(dataInicial))
      setDataFinal(addMonths(dataInicial, 1));
  }, [dataInicial]);

  useEffect(() => {
    if (Math.abs(differenceInDays(dataInicial, dataFinal)) > getDaysInMonth(dataFinal))
      setDataInicial(subMonths(dataFinal, 1));
  }, [dataFinal]);

  //TODO: verificar se esta retornando todos os artigos selecionados
  return (
    <ContainerPage
      titulo="Dashboard"
      componenteLateral={
        <Typography className="flex flex-row items-center" component="body1-descricao">
          Conta do Google Analytics sincronizada, acesso a dados precisos de tráfego e análises do
          blog
          <MdOutlineInfo className="h-6 w-6 text-grey-medium ml-1" />
          <ModalAnalytics valorInicial={analytics} />
        </Typography>
      }
    >
      <div className="flex gap-4 items-start">
        <PanoramaGeral />
        <ResultadoPalavraChave artigoIds={artigoIds} />
      </div>
      <VisaoGeralArtigos artigoIds={artigoIds} postLength={postLength}/>
      <ArtigosRascunhoIA />
    </ContainerPage>
  );
}
